import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface ClusterAddressListCardProps {
    clusterAddresses: any[];
    onAddressClick: (address: string, orders: any[]) => void;
}

const ClusterAddressListCard: React.FC<ClusterAddressListCardProps> = ({
    clusterAddresses,
    onAddressClick
}) => {
    const { t } = useTranslation();
    const addressGroups = useMemo(() => {
        const groups = new Map<string, any[]>();
        console.log('📍 ClusterAddressListCard 收到的订单:', clusterAddresses);

        clusterAddresses.forEach(order => {
            // 🎯 获取标准化地址
            const standardizedAddress = order.standardizedAddressString || 
                order.orderWithAddress?.deliveryAddress?.standardizedAddressString ||
                order.address;
            
            console.log('📍 订单地址:', standardizedAddress);

            if (!groups.has(standardizedAddress)) {
                groups.set(standardizedAddress, []);
            }
            groups.get(standardizedAddress)!.push(order);
        });
        
        console.log('📍 分组后的地址数量:', groups.size);

        const result = Array.from(groups.entries()).map(([address, orders]) => {
            const sortedOrders = [...orders].sort((a, b) => (a.stopNumber || 0) - (b.stopNumber || 0));
            return {
                address,
                orderCount: orders.length,
                orders: sortedOrders,
                minStopNumber: sortedOrders[0].stopNumber || 0
            };
        });

        result.sort((a, b) => a.minStopNumber - b.minStopNumber);

        return result;
    }, [clusterAddresses]);

    return (
        <div className="flex flex-col bg-gray-50 max-h-[70vh] overflow-y-auto">
            <div className="px-4 py-2">
                <div className="space-y-3 pb-4">
                    {addressGroups.map((group) => (
                        <div
                            key={group.address}
                            className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden cursor-pointer active:bg-gray-50 transition-colors relative"
                            onClick={() => onAddressClick(group.address, group.orders)}
                        >
                            {group.orderCount > 1 && (
                                <div className="absolute top-0 left-0 px-2 py-1 bg-blue-500 text-white text-xs font-medium rounded-tl-xl"
                                     onClick={() => onAddressClick(group.address, group.orders)}>
                                    {t('pages.delivery.temporary.mapMode.sameAddressCount', { count: group.orderCount })}
                                </div>
                            )}
                            <div className={`px-4 text-base text-gray-900 leading-relaxed ${group.orderCount > 1 ? 'pt-10 pb-3' : 'py-3'}`}>
                                {group.address}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ClusterAddressListCard;
